
define('tpl!taoDelivery/tpl/fullscreen-modal-feedback', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "(";
  if (helper = helpers.launchButton) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.launchButton); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + ")";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\r\n            <button class=\"btn-info small enter-full-screen\" type=\"button\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Enter full screen", options) : helperMissing.call(depth0, "__", "Enter full screen", options)))
    + "</button>\r\n            ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\r\n            <button class=\"btn-info small close-full-screen-prompt\" type=\"button\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Close this prompt", options) : helperMissing.call(depth0, "__", "Close this prompt", options)))
    + "</button>\r\n            ";
  return buffer;
  }

  buffer += "<div class=\"modal-feedback modal full-screen-modal\">\r\n    <div class=\"modal-body clearfix\">\r\n        <p class=\"message\">\r\n            "
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "This test needs to be taken in full screen mode", options) : helperMissing.call(depth0, "__", "This test needs to be taken in full screen mode", options)))
    + "\r\n            ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.fsSupported), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n        </p>\r\n        <div class=\"rgt\">\r\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.fsSupported), {hash:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n        </div>\r\n    </div>\r\n</div>";
  return buffer;
  });
});

